import { render } from "./PolicyProvisionImportModal.vue?vue&type=template&id=7f13c3e2&scoped=true"
import script from "./PolicyProvisionImportModal.vue?vue&type=script&lang=js"
export * from "./PolicyProvisionImportModal.vue?vue&type=script&lang=js"

import "./PolicyProvisionImportModal.vue?vue&type=style&index=0&id=7f13c3e2&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f13c3e2"]])

export default __exports__